/* eslint camelcase: 0 */
__webpack_public_path__ = `${window.STATIC_URL}build/js/`;



// WEBPACK FOOTER //
// ./static-source/js/public_path.js